import React from 'react';
import Slider from 'react-slick';
import { Box } from '@mui/material';
import { GrCertificate } from "react-icons/gr";
import { PiStudentFill } from "react-icons/pi";
import { LuBookMarked } from "react-icons/lu";
import { BiMaleFemale } from "react-icons/bi";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Events = () => {
    const list = [
        {
            icon: GrCertificate,
            count: "15",
            title: "COURSES",
        },
        {
            icon: PiStudentFill,
            count: "100%",
            title: "UNIVERSITY PLACEMENT",
        },
        {
            icon: LuBookMarked,
            count: "200+",
            title: "UNIVERSITY PLACEMENT IN PAKISTAN",
        },
        {
            icon: BiMaleFemale,
            count: "100%",
            title: "40+ CLUB",
        },
    ];

    const sliderSettings = {
        infinite: true,
        speed: 2000,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow: 3,
        slidesToScroll: 1,
        gap: 20,
        arrows: false,
        cssEase: 'linear',
    };

    return (
        <section
            className='bg-fixed bg-center bg-no-repeat bg-cover h-fit p-50 bg-myBlue/80'
            style={{ backgroundImage: `url('/why.jpg')` }}>

            <div className="top-0 left-0 w-full h-fit py-6 bg-myBlue/80">

                <h6 style={{ fontFamily: "Montserrat" }} className='md:text-[20px] text-white w-fit mx-auto z-40 opacity-100'>
                    THE NUMBERS SAY IT ALL
                </h6>
                <h1 style={{ fontFamily: "Montserrat" }} className='md:text-[35px] font-semibold text-white w-fit mx-auto z-40 opacity-100'>
                    WHY CHOOSE US
                </h1>

                {/* Slider for Events */}
                <Slider {...sliderSettings}>
                    {list.map((item, index) => (
                        <Box
                            key={index}
                            sx={{
                                
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexDirection: 'column',
                                textAlign: 'center',
                                padding: 2,
                                
                            }}
                        >
                             <Box
                                className="mb-2 flex justify-center"
                                sx={{
                                    fontSize: { xs: '24px', sm: '30px', md: '50px' }, // Responsive icon size
                                }}
                            >
                                <item.icon className="text-myYellow" />
                            </Box>
                            {/* 
                            <item.icon className="text-[50px] text-myYellow mb-2" /> */}
                            <h1
                                className="text-[#f2f3f6] mb-2"
                                style={{
                                    fontSize: 'calc(30px + 1vw)', // Responsive font size for count
                                }}
                            >
                                {item.count}
                            </h1>

                            {/* Title */}
                            <p
                                className="text-[#e8dcdc] mb-4"
                                style={{
                                    fontSize: 'calc(12px + 0.8vw)', // Responsive font size for title
                                }}
                            >
                                {item.title}
                            </p>
                            
                        </Box>
                    ))}
                </Slider>

            </div>
        </section>
    );
};

export default Events;
